export default __webpack_public_path__ + "010059cae85f29c0c79da2c1ba7c7d5e.png";